var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isRecord)?_c('SignInData',{on:{"getRecord":_vm.getRecord}}):_c('SignInRecord',{on:{"getData":_vm.getData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }